// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__iO5oK","title":"WelcomeBanner_title__T-2hp","appEntry":"WelcomeBanner_appEntry__Tu+nY","appGrid":"WelcomeBanner_appGrid__TBFfg"};